<template>
  <div class="page">
    <HeaderTop :is_login="false"></HeaderTop>
    <div class="pageContent d-flex d-flex-middle d-flex-center">
      <div class="bmContent" :class="{ 'p0': showMajorPlanDetail }">
        <a href="javascript:void(0)" class="back-link" v-if="!showMajorPlanDetail" @click="handleBack">
          <em style="position: relative;top: -1px;">&lt;</em> 返回
        </a>
        <div class="progressBox" v-if="!showMajorPlanDetail">
          <BmProgress :steps="steps" :current-step="2" />
        </div>
        <div class="contentBox" :class="{ 'full-width': showMajorPlanDetail }">
          <SelectMajor 
            v-if="!showMajorPlanDetail" 
            @prev-step="handlePrev" 
            @next-step="handleNext" 
            @view-plan="handleViewPlan" 
          />
          <planDetail 
            v-else 
            :specId="specId" 
            @back="handleBackFromPlanDetail"
            @register="handleRegisterFromPlanDetail"
          />
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import BmProgress from "@/components/bm/bmProgress.vue";
import SelectMajor from "@/components/bm/selectMajor.vue";
import planDetail from "@/components/bm/planDetail.vue";

export default {
  name: 'Step2SelectMajor',
  components: {
    HeaderTop,
    Footer,
    BmProgress,
    SelectMajor,
    planDetail
  },
  data() {
    return {
      steps: [
        { title: '阅读报名须知' },
        { title: '选择就读地点' },
        { title: '选择报名专业' },
        { title: '注册资料' },
        { title: '提交报名' },
        { title: '缴费' }
      ],
      showMajorPlanDetail: false,
      specId: {}
    }
  },
  methods: {
    // 返回按钮点击事件
    handleBack() {
      this.$router.push({ name: 'BmStepSelectLocation' })
    },
    handlePrev() {
      if (this.showMajorPlanDetail) {
        this.handleBackFromPlanDetail()
      } else {
        this.$router.push({ name: 'BmStepSelectLocation' })
      }
    },
    handleNext(id) {
      localStorage.setItem('specId', id)
      this.$router.push({ name: 'BmStepRegisterInfo' })
    },
    handleViewPlan(id) {
      this.specId = id
      this.showMajorPlanDetail = true
    },
    handleBackFromPlanDetail() {
      this.showMajorPlanDetail = false
      this.specId = null
    },
    handleRegisterFromPlanDetail(id) {
      localStorage.setItem('specId', id)
      this.showMajorPlanDetail = false
      this.$router.push({ name: 'BmStepRegisterInfo' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  position: relative;
}

.pageContent {
  padding: 20px;
  min-height: calc(100vh - 200px);
  margin-top: 70px;
  background: url('../../assets/bm/bmBg.png') no-repeat center center;
  background-size: 100% 100%;
}

.bmContent {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  
  &.p0 {
    padding: 0;
  }
}

.back-link {
  margin-bottom: 20px;
  display: inline-block;
  color: #767676;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}

.progressBox {
  width: 100%;
  margin-bottom: 20px;
}

.contentBox {
  width: 1000px;
  margin: 0 auto;
  border-top: 1px solid #E9EFF9;
  
  &.full-width {
    width: 100%;
    border-top: none;
  }
}
</style>
